'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Props {
  total: number;
  sortBy: string;
  onSortChange: (v: string) => void;
  viewMode: 'grid' | 'list';
  onViewChange: (v: 'grid' | 'list') => void;
}

const sortOptions = [
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'area-desc', label: 'Largest Area' },
  { value: 'yield-desc', label: 'Highest Yield' },
];

export default function SortBar({ total, sortBy, onSortChange, viewMode, onViewChange }: Props) {
  return (
    <div className="flex items-center justify-between bg-card border border-border rounded-xl px-4 py-3">
      <p className="text-sm text-muted-foreground">
        <span className="font-bold text-foreground font-tabular">{total}</span> properties found
      </p>
      <div className="flex items-center gap-3">
        <select
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
          className="text-sm border border-border rounded-lg px-3 py-1.5 bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
        >
          {sortOptions.map((o) => (
            <option key={`sort-${o.value}`} value={o.value}>{o.label}</option>
          ))}
        </select>
        <div className="flex items-center border border-border rounded-lg overflow-hidden">
          <button
            onClick={() => onViewChange('grid')}
            className={`p-2 transition-colors ${viewMode === 'grid' ? 'bg-primary text-white' : 'text-muted-foreground hover:bg-muted'}`}
            aria-label="Grid view"
          >
            <Icon name="Squares2X2Icon" size={16} />
          </button>
          <button
            onClick={() => onViewChange('list')}
            className={`p-2 transition-colors ${viewMode === 'list' ? 'bg-primary text-white' : 'text-muted-foreground hover:bg-muted'}`}
            aria-label="List view"
          >
            <Icon name="ListBulletIcon" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}